import React, { useState, useEffect } from "react";
import CircularProgress from "@mui/material/CircularProgress";

import AutocompleteMd, { AutocompleteProps } from "@mui/material/Autocomplete";
import TextInput from "Components/TextInput";

// interface Props<T>
// 	extends Omit<AutocompleteProps<T>, "renderInput" | "options"> {
// 	name?: string;
// 	defaultValue?: T;
// 	loadOptions: (term: string, callback: (data: any[]) => void) => void;
// 	onChange(id: string, value: string): void;
// 	errors?: any;
// }

function AutoComplete({
	id,
	name,
	loading,
	loadOptions,
	defaultValue = null,
	errors,
	onChange,
	...rest
}: any) {
	const [data, setData] = useState([]);
	const [open, setOpen] = useState(false);
	const [term, setTerm] = useState("");
	const [value, setValue] = useState(defaultValue);

	useEffect(() => {
		if (open) {
			loadOptions(term, (d: any) => setData(d));
		}
	}, [open, term]);

	return (
		<AutocompleteMd
			id={`${id}-auto-complete`}
			open={open}
			onOpen={() => {
				setOpen(true);
			}}
			onClose={() => {
				setOpen(false);
			}}
			loading={open && loading}
			options={data}
			value={value}
			onChange={(e, v: any, r) => {
				setValue(v);
				onChange(id, v?.id);
			}}
			getOptionSelected={(option: any, value: any) => option.id === value.id}
			getOptionLabel={(option: any) => option.label}
			renderInput={params => {
				return (
					<TextInput
						{...params}
						id={id}
						name={name}
						value={term}
						errors={errors}
						onChange={(id, v) => setTerm(v)}
						variant="outlined"
						InputProps={{
							...params.InputProps,
							endAdornment: (
								<React.Fragment>
									{open && loading ? (
										<CircularProgress color="inherit" size={20} />
									) : null}
									{params.InputProps.endAdornment}
								</React.Fragment>
							)
						}}
					/>
				);
			}}
			{...rest}
		/>
	);
}

export default AutoComplete;
